export default function Heading(props) {
    return (
        <div className='relative w-full flex flex-col items-center bg-stone-100 px-site bg-cover bg-center' style={{ backgroundImage: 'url(' + props.image + ')' }}>

            <div className='absolute w-full h-full top-0 left-0 bg-gradient-to-r from-black/70 to-black/20' />

            <div className='w-full max-w-boxed flex flex-col pt-16 md:pt-32 pb-16 z-10'>
                <div className='text-white text-3xl sm:text-4xl lg:text-6xl font-bold' dangerouslySetInnerHTML={{ __html: props.title }} />
            </div>

        </div>
    );
}